import { render, staticRenderFns } from "./multi-weight.vue?vue&type=template&id=ca2935c8&scoped=true"
import script from "./multi-weight.vue?vue&type=script&lang=ts"
export * from "./multi-weight.vue?vue&type=script&lang=ts"
import style0 from "./multi-weight.vue?vue&type=style&index=0&id=ca2935c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2935c8",
  null
  
)

export default component.exports